import { Trans } from '@lingui/macro'
import Column from 'components/Column'
import { RowBetween } from 'components/Row'
import Toggle from 'components/Toggle'
import styled from 'styled-components/macro'
import { ThemedText } from 'theme'

const Notice = styled(ThemedText.Caption)`
  color: ${({ theme }) => theme.accentWarning};
  background: ${({ theme }) => theme.accentWarning}11;
  border-radius: 6px;
  padding: 8px 10px;
`

interface ReceiverSettingsProps {
  enabled: boolean
  onToggle: () => void
}

export default function ReceiverSettings({ enabled, onToggle }: ReceiverSettingsProps) {
  return (
    <Column gap="sm">
      <RowBetween gap="sm">
        <Column gap="xs">
          <ThemedText.BodySecondary color="textPrimary">
            <Trans>Receiver Address</Trans>
          </ThemedText.BodySecondary>
          <ThemedText.Caption color="textSecondary">
            <Trans>Send swap proceeds to a different wallet.</Trans>
          </ThemedText.Caption>
        </Column>
        <Toggle id="toggle-receiver-address" isActive={enabled} toggle={onToggle} />
      </RowBetween>
      {enabled && (
        <Notice>
          <Trans>The receiver address modal is available on the swap page.</Trans>
        </Notice>
      )}
    </Column>
  )
}
